var map = {
	"./Icon_Library/application icons/api/data_mapping.svg2": 15026,
	"./Icon_Library/application icons/api/icon_3rd_party_api.svg2": 60038,
	"./Icon_Library/application icons/api/icon_advanced_settings.svg2": 24475,
	"./Icon_Library/application icons/api/icon_business_hours.svg2": 52873,
	"./Icon_Library/application icons/api/icon_data.svg2": 903,
	"./Icon_Library/application icons/api/icon_log_files.svg2": 2175,
	"./Icon_Library/application icons/api/icon_logic_api.svg2": 83316,
	"./Icon_Library/application icons/api/icon_message_api.svg2": 23089,
	"./Icon_Library/application icons/api/icon_projects.svg2": 96725,
	"./Icon_Library/application icons/api/icon_testing.svg2": 3393,
	"./Icon_Library/application icons/api/icon_type_choose.svg2": 61405,
	"./Icon_Library/application icons/api/icon_verify.svg2": 79206,
	"./Icon_Library/application icons/api/import_side.svg2": 20592,
	"./Icon_Library/application icons/api/overview.svg2": 85584,
	"./Icon_Library/application icons/assets/asset_types/alert_building-01.svg2": 34740,
	"./Icon_Library/application icons/assets/asset_types/alert_fire-01.svg2": 68676,
	"./Icon_Library/application icons/assets/asset_types/alert_human_triggered-01.svg2": 77605,
	"./Icon_Library/application icons/assets/asset_types/alert_it-01.svg2": 5723,
	"./Icon_Library/application icons/assets/asset_types/alert_physical-01.svg2": 93931,
	"./Icon_Library/application icons/assets/asset_types/alert_power-01.svg2": 65575,
	"./Icon_Library/application icons/assets/asset_types/alert_stock-01.svg2": 26290,
	"./Icon_Library/application icons/assets/asset_types/alert_traffic_transportation-01.svg2": 56492,
	"./Icon_Library/application icons/assets/asset_types/alert_weather-01.svg2": 91256,
	"./Icon_Library/application icons/assets/assets.svg2": 27965,
	"./Icon_Library/application icons/assets/contacts_main.svg2": 32659,
	"./Icon_Library/application icons/assets/events.svg2": 56805,
	"./Icon_Library/application icons/assets/events/activate-01.svg2": 46877,
	"./Icon_Library/application icons/assets/events/add_circle-01.svg2": 20974,
	"./Icon_Library/application icons/assets/events/asset_events/asset.svg2": 29709,
	"./Icon_Library/application icons/assets/events/asset_events/human-01.svg2": 89564,
	"./Icon_Library/application icons/assets/events/asset_events/location_office-01.svg2": 54623,
	"./Icon_Library/application icons/assets/events/asset_events/location_school-01.svg2": 33783,
	"./Icon_Library/application icons/assets/events/asset_events/regional_office_hq-01.svg2": 66701,
	"./Icon_Library/application icons/assets/events/asset_events/server-01.svg2": 82572,
	"./Icon_Library/application icons/assets/events/asset_events/vehicle.svg2": 39545,
	"./Icon_Library/application icons/assets/events/assets_contacts-01.svg2": 30943,
	"./Icon_Library/application icons/assets/events/created_by-01.svg2": 77482,
	"./Icon_Library/application icons/assets/events/details-01.svg2": 15412,
	"./Icon_Library/application icons/assets/events/edit-01.svg2": 10514,
	"./Icon_Library/application icons/assets/events/event_start_end_cal-.svg2": 78911,
	"./Icon_Library/application icons/assets/events/event_type_alert-01.svg2": 59810,
	"./Icon_Library/application icons/assets/events/event_type_event-01.svg2": 96056,
	"./Icon_Library/application icons/assets/events/event_type_notification-01.svg2": 18241,
	"./Icon_Library/application icons/assets/events/import_event-01.svg2": 89656,
	"./Icon_Library/application icons/assets/events/layers/layer_bike-01.svg2": 98510,
	"./Icon_Library/application icons/assets/events/layers/layer_traffic-01.svg2": 64516,
	"./Icon_Library/application icons/assets/events/layers/layer_transit-01.svg2": 56866,
	"./Icon_Library/application icons/assets/events/locations/location_office-01.svg2": 13487,
	"./Icon_Library/application icons/assets/events/locations/location_school-01.svg2": 59143,
	"./Icon_Library/application icons/assets/events/logic_project-01.svg2": 40350,
	"./Icon_Library/application icons/assets/events/map_layers-01.svg2": 13657,
	"./Icon_Library/application icons/assets/events/one_off_comms-01.svg2": 99842,
	"./Icon_Library/application icons/assets/events/recipients-01.svg2": 1682,
	"./Icon_Library/application icons/assets/events/remove-01.svg2": 70542,
	"./Icon_Library/application icons/assets/events/send_method-01.svg2": 27064,
	"./Icon_Library/application icons/assets/events/step_complete-01.svg2": 56114,
	"./Icon_Library/application icons/assets/events/ticker-01.svg2": 52604,
	"./Icon_Library/application icons/assets/events/ticker_hide-01.svg2": 85399,
	"./Icon_Library/application icons/assets/events/ticker_pause-01.svg2": 2879,
	"./Icon_Library/application icons/assets/events/ticket_details-01.svg2": 31893,
	"./Icon_Library/application icons/assets/events/timeline-01.svg2": 37255,
	"./Icon_Library/application icons/assets/events/types/type_fire-01.svg2": 5039,
	"./Icon_Library/application icons/assets/events/types/type_terrorist-01.svg2": 20247,
	"./Icon_Library/application icons/assets/events/types/type_traffic-01.svg2": 62762,
	"./Icon_Library/application icons/assets/events/types/type_weather.svg2": 82043,
	"./Icon_Library/application icons/assets/groups.svg2": 74160,
	"./Icon_Library/application icons/assets/map_pin.svg2": 96226,
	"./Icon_Library/application icons/assets/weather.svg2": 70608,
	"./Icon_Library/application icons/billing/billing.svg2": 15949,
	"./Icon_Library/application icons/billing/billing_details.svg2": 97916,
	"./Icon_Library/application icons/billing/calendar_basic.svg2": 95381,
	"./Icon_Library/application icons/billing/inbound_numbers.svg2": 81550,
	"./Icon_Library/application icons/billing/invoices.svg2": 15254,
	"./Icon_Library/application icons/billing/overview.svg2": 30213,
	"./Icon_Library/application icons/billing/payment_methods.svg2": 23677,
	"./Icon_Library/application icons/billing/postpaid.svg2": 42902,
	"./Icon_Library/application icons/billing/status.svg2": 59444,
	"./Icon_Library/application icons/dashboard/create_api_connection.svg2": 10441,
	"./Icon_Library/application icons/dashboard/create_boomlogic.svg2": 61319,
	"./Icon_Library/application icons/dashboard/create_broadcast.svg2": 85711,
	"./Icon_Library/application icons/dashboard/create_inbound.svg2": 31761,
	"./Icon_Library/application icons/dashboard/icon_3rd_party_api.svg2": 99210,
	"./Icon_Library/application icons/dashboard/icon_logic_api.svg2": 71144,
	"./Icon_Library/application icons/dashboard/icon_message_api.svg2": 41181,
	"./Icon_Library/application icons/general/add_circle.svg2": 20983,
	"./Icon_Library/application icons/general/admin_alt_a.svg2": 16358,
	"./Icon_Library/application icons/general/admin_alt_b.svg2": 19247,
	"./Icon_Library/application icons/general/alerts.svg2": 63428,
	"./Icon_Library/application icons/general/api_type.svg2": 3354,
	"./Icon_Library/application icons/general/arrow_right.svg2": 84445,
	"./Icon_Library/application icons/general/attach.svg2": 40838,
	"./Icon_Library/application icons/general/bolt.svg2": 4844,
	"./Icon_Library/application icons/general/boom_calendar.svg2": 38255,
	"./Icon_Library/application icons/general/boomlocal-forward.svg2": 53011,
	"./Icon_Library/application icons/general/bulk_manage.svg2": 57015,
	"./Icon_Library/application icons/general/button_logic_ready.svg2": 75462,
	"./Icon_Library/application icons/general/cal_event.svg2": 92290,
	"./Icon_Library/application icons/general/calendar.svg2": 97885,
	"./Icon_Library/application icons/general/chevon_down.svg2": 76191,
	"./Icon_Library/application icons/general/close.svg2": 35849,
	"./Icon_Library/application icons/general/cog.svg2": 27850,
	"./Icon_Library/application icons/general/comm_fields.svg2": 74205,
	"./Icon_Library/application icons/general/comms-delay.svg2": 42702,
	"./Icon_Library/application icons/general/concat.svg2": 67039,
	"./Icon_Library/application icons/general/connections.svg2": 79268,
	"./Icon_Library/application icons/general/contact_edit.svg2": 61946,
	"./Icon_Library/application icons/general/contact_support.svg2": 26033,
	"./Icon_Library/application icons/general/data_mapping.svg2": 31754,
	"./Icon_Library/application icons/general/edit.svg2": 8523,
	"./Icon_Library/application icons/general/engineer.svg2": 30082,
	"./Icon_Library/application icons/general/engineer_visit.svg2": 40094,
	"./Icon_Library/application icons/general/export.svg2": 16457,
	"./Icon_Library/application icons/general/filter.svg2": 41125,
	"./Icon_Library/application icons/general/free_build.svg2": 52862,
	"./Icon_Library/application icons/general/fulfilment.svg2": 89225,
	"./Icon_Library/application icons/general/groups_add.svg2": 40855,
	"./Icon_Library/application icons/general/import.svg2": 62678,
	"./Icon_Library/application icons/general/import_side.svg2": 39336,
	"./Icon_Library/application icons/general/incident_report.svg2": 99712,
	"./Icon_Library/application icons/general/info.svg2": 27687,
	"./Icon_Library/application icons/general/ldap.svg2": 14558,
	"./Icon_Library/application icons/general/manage_fields.svg2": 8272,
	"./Icon_Library/application icons/general/mapping.svg2": 34583,
	"./Icon_Library/application icons/general/marketing_fields.svg2": 94127,
	"./Icon_Library/application icons/general/masking.svg2": 1365,
	"./Icon_Library/application icons/general/message_recipients.svg2": 18879,
	"./Icon_Library/application icons/general/messages.svg2": 95447,
	"./Icon_Library/application icons/general/messages_processed.svg2": 37792,
	"./Icon_Library/application icons/general/messenger.svg2": 70534,
	"./Icon_Library/application icons/general/movable.svg2": 10915,
	"./Icon_Library/application icons/general/num-status.svg2": 32710,
	"./Icon_Library/application icons/general/num-validation.svg2": 11443,
	"./Icon_Library/application icons/general/omni-channel.svg2": 98512,
	"./Icon_Library/application icons/general/opt-in-out.svg2": 46761,
	"./Icon_Library/application icons/general/originator.svg2": 54053,
	"./Icon_Library/application icons/general/personal_details.svg2": 81838,
	"./Icon_Library/application icons/general/plus.svg2": 34423,
	"./Icon_Library/application icons/general/preview.svg2": 9522,
	"./Icon_Library/application icons/general/print.svg2": 60978,
	"./Icon_Library/application icons/general/prod_api.svg2": 96673,
	"./Icon_Library/application icons/general/prod_boomlogic.svg2": 95214,
	"./Icon_Library/application icons/general/prod_broadcast.svg2": 80842,
	"./Icon_Library/application icons/general/prod_inbound.svg2": 13312,
	"./Icon_Library/application icons/general/profile_fields.svg2": 13688,
	"./Icon_Library/application icons/general/redo.svg2": 62739,
	"./Icon_Library/application icons/general/reports_export.svg2": 65689,
	"./Icon_Library/application icons/general/reports_generate.svg2": 51632,
	"./Icon_Library/application icons/general/reports_saved.svg2": 32566,
	"./Icon_Library/application icons/general/required_fields.svg2": 58566,
	"./Icon_Library/application icons/general/satisfaction_survey.svg2": 13418,
	"./Icon_Library/application icons/general/save.svg2": 39042,
	"./Icon_Library/application icons/general/schedule_send.svg2": 27329,
	"./Icon_Library/application icons/general/scheduling.svg2": 63805,
	"./Icon_Library/application icons/general/search.svg2": 81075,
	"./Icon_Library/application icons/general/secure_lock..svg2": 80062,
	"./Icon_Library/application icons/general/self-manage.svg2": 11567,
	"./Icon_Library/application icons/general/send.svg2": 38237,
	"./Icon_Library/application icons/general/service_entries.svg2": 86725,
	"./Icon_Library/application icons/general/shortlink.svg2": 95043,
	"./Icon_Library/application icons/general/sla.svg2": 93179,
	"./Icon_Library/application icons/general/sms_text.svg2": 85474,
	"./Icon_Library/application icons/general/social-hours.svg2": 31790,
	"./Icon_Library/application icons/general/social_fb.svg2": 92281,
	"./Icon_Library/application icons/general/social_li.svg2": 13122,
	"./Icon_Library/application icons/general/social_x.svg2": 33679,
	"./Icon_Library/application icons/general/support_ticket.svg2": 51367,
	"./Icon_Library/application icons/general/switch_refresh.svg2": 77099,
	"./Icon_Library/application icons/general/system_usage.svg2": 75998,
	"./Icon_Library/application icons/general/template_account.svg2": 44921,
	"./Icon_Library/application icons/general/template_boomerang.svg2": 58998,
	"./Icon_Library/application icons/general/template_helper.svg2": 83046,
	"./Icon_Library/application icons/general/tick.svg2": 23958,
	"./Icon_Library/application icons/general/tick_circled.svg2": 65817,
	"./Icon_Library/application icons/general/tick_list.svg2": 27887,
	"./Icon_Library/application icons/general/timezones.svg2": 66137,
	"./Icon_Library/application icons/general/undo.svg2": 96525,
	"./Icon_Library/application icons/general/unicode.svg2": 37578,
	"./Icon_Library/application icons/general/unrec-response.svg2": 24170,
	"./Icon_Library/application icons/general/upgrades.svg2": 89102,
	"./Icon_Library/application icons/general/upload.svg2": 13214,
	"./Icon_Library/application icons/general/upload_file-01.svg2": 16083,
	"./Icon_Library/application icons/general/user_group.svg2": 8084,
	"./Icon_Library/application icons/general/web-forms.svg2": 24841,
	"./Icon_Library/application icons/general/whatsapp.svg2": 33413,
	"./Icon_Library/application icons/general/xls_files.svg2": 19216,
	"./Icon_Library/application icons/interactions/interactions.svg2": 40209,
	"./Icon_Library/application icons/library/api_data_connections.svg2": 18949,
	"./Icon_Library/application icons/library/api_profiles.svg2": 3801,
	"./Icon_Library/application icons/library/boomAI_icon.svg2": 77557,
	"./Icon_Library/application icons/library/boomAI_icon_white.svg2": 60071,
	"./Icon_Library/application icons/library/contacts_main.svg2": 61649,
	"./Icon_Library/application icons/library/icon_translate.svg2": 76534,
	"./Icon_Library/application icons/library/library.svg2": 29413,
	"./Icon_Library/application icons/library/library_broadcast.svg2": 6233,
	"./Icon_Library/application icons/library/library_documents.svg2": 43564,
	"./Icon_Library/application icons/library/library_logic.svg2": 740,
	"./Icon_Library/application icons/library/solutions.svg2": 99634,
	"./Icon_Library/application icons/library/weather.svg2": 96074,
	"./Icon_Library/application icons/menus/main navigation/boomerang_element-01.svg2": 72092,
	"./Icon_Library/application icons/menus/main navigation/logout.svg2": 37487,
	"./Icon_Library/application icons/menus/main navigation/nav_assets.svg2": 65862,
	"./Icon_Library/application icons/menus/main navigation/nav_billing.svg2": 57626,
	"./Icon_Library/application icons/menus/main navigation/nav_contacts.svg2": 57998,
	"./Icon_Library/application icons/menus/main navigation/nav_dashboard.svg2": 52885,
	"./Icon_Library/application icons/menus/main navigation/nav_interactions.svg2": 47142,
	"./Icon_Library/application icons/menus/main navigation/nav_monitoring.svg2": 93969,
	"./Icon_Library/application icons/menus/main navigation/nav_reports.svg2": 47574,
	"./Icon_Library/application icons/menus/main navigation/nav_settings.svg2": 40062,
	"./Icon_Library/application icons/menus/main navigation/nav_templates.svg2": 45726,
	"./Icon_Library/application icons/menus/top navigation/chevon_down.svg2": 60033,
	"./Icon_Library/application icons/menus/top navigation/docs.svg2": 73282,
	"./Icon_Library/application icons/menus/top navigation/info.svg2": 66257,
	"./Icon_Library/application icons/menus/top navigation/live_chat.svg2": 57210,
	"./Icon_Library/application icons/menus/top navigation/menu.svg2": 2474,
	"./Icon_Library/application icons/monitoring/alerts_notifications-01.svg2": 10939,
	"./Icon_Library/application icons/monitoring/check_tick-01.svg2": 33123,
	"./Icon_Library/application icons/monitoring/configuration-01.svg2": 44499,
	"./Icon_Library/application icons/monitoring/icon_alert.svg2": 24853,
	"./Icon_Library/application icons/monitoring/icon_heartbeat_1.svg2": 69451,
	"./Icon_Library/application icons/monitoring/icon_heartbeat_2.svg2": 61666,
	"./Icon_Library/application icons/monitoring/icon_ping .svg2": 55703,
	"./Icon_Library/application icons/monitoring/industries/industry_construction-01.svg2": 4510,
	"./Icon_Library/application icons/monitoring/map_view-01.svg2": 1973,
	"./Icon_Library/application icons/monitoring/monitor_types/mon_environmental_conditions-01.svg2": 12048,
	"./Icon_Library/application icons/monitoring/monitor_types/mon_remote_devices-01.svg2": 35187,
	"./Icon_Library/application icons/monitoring/monitor_types/mon_weather.svg2": 39825,
	"./Icon_Library/application icons/monitoring/monitor_types/mon_welfare-01.svg2": 64951,
	"./Icon_Library/application icons/monitoring/monitoring-01.svg2": 71229,
	"./Icon_Library/application icons/monitoring/monitors_overview-01.svg2": 47356,
	"./Icon_Library/application icons/monitoring/save-01.svg2": 62616,
	"./Icon_Library/application icons/monitoring/select_workflow-01.svg2": 64585,
	"./Icon_Library/application icons/monitoring/setup-01.svg2": 62014,
	"./Icon_Library/application icons/monitoring/view_manage_monitors-01.svg2": 93788,
	"./Icon_Library/application icons/reports/assets.svg2": 89399,
	"./Icon_Library/application icons/reports/billing.svg2": 2085,
	"./Icon_Library/application icons/reports/features.svg2": 73633,
	"./Icon_Library/application icons/reports/messaging_data.svg2": 52067,
	"./Icon_Library/application icons/reports/process_reports.svg2": 17587,
	"./Icon_Library/application icons/reports/realtime_reporting.svg2": 18386,
	"./Icon_Library/application icons/reports/reporting_analytical.svg2": 59507,
	"./Icon_Library/application icons/reports/reporting_system.svg2": 86316,
	"./Icon_Library/application icons/reports/reports.svg2": 94101,
	"./Icon_Library/application icons/reports/tiket_reporting.svg2": 6218,
	"./Icon_Library/application icons/reports/workflows.svg2": 15860,
	"./Icon_Library/application icons/settings/comms_defaults.svg2": 25744,
	"./Icon_Library/application icons/settings/communications.svg2": 31805,
	"./Icon_Library/application icons/settings/company.svg2": 13964,
	"./Icon_Library/application icons/settings/invoices.svg2": 27768,
	"./Icon_Library/application icons/settings/organisation.svg2": 67806,
	"./Icon_Library/application icons/settings/security.svg2": 77090,
	"./Icon_Library/application icons/settings/settings.svg2": 60793,
	"./Icon_Library/application icons/settings/sms_settings.svg2": 25679,
	"./Icon_Library/application icons/settings/status.svg2": 26738,
	"./Icon_Library/application icons/settings/timezones.svg2": 19416,
	"./Icon_Library/application icons/settings/users.svg2": 85940,
	"./Icon_Library/application icons/settings/users_roles.svg2": 18430,
	"./Icon_Library/application icons/weather/codes_conditions/clear_sky-01.svg2": 47078,
	"./Icon_Library/application icons/weather/codes_conditions/cloudy-01.svg2": 1117,
	"./Icon_Library/application icons/weather/codes_conditions/drizzle-01.svg2": 25077,
	"./Icon_Library/application icons/weather/codes_conditions/fog-01.svg2": 32351,
	"./Icon_Library/application icons/weather/codes_conditions/heavy_rain-01.svg2": 38067,
	"./Icon_Library/application icons/weather/codes_conditions/heavy_rain_shower-01.svg2": 27648,
	"./Icon_Library/application icons/weather/codes_conditions/heavy_snow-01.svg2": 39060,
	"./Icon_Library/application icons/weather/codes_conditions/heavy_snow_shower-01.svg2": 44309,
	"./Icon_Library/application icons/weather/codes_conditions/light_rain-01.svg2": 94568,
	"./Icon_Library/application icons/weather/codes_conditions/light_rain_shower-01.svg2": 58913,
	"./Icon_Library/application icons/weather/codes_conditions/light_snow-01.svg2": 12891,
	"./Icon_Library/application icons/weather/codes_conditions/light_snow_shower-01.svg2": 34760,
	"./Icon_Library/application icons/weather/codes_conditions/max_screen_temp-01.svg2": 56429,
	"./Icon_Library/application icons/weather/codes_conditions/min_screen_temp-01.svg2": 50563,
	"./Icon_Library/application icons/weather/codes_conditions/mist-01.svg2": 13406,
	"./Icon_Library/application icons/weather/codes_conditions/overcast-01.svg2": 55754,
	"./Icon_Library/application icons/weather/codes_conditions/partly_cloudy-01.svg2": 36398,
	"./Icon_Library/application icons/weather/codes_conditions/probability_of_snow_visibility-01.svg2": 22743,
	"./Icon_Library/application icons/weather/codes_conditions/significant_weather-01.svg2": 34139,
	"./Icon_Library/application icons/weather/codes_conditions/sleet-01.svg2": 46030,
	"./Icon_Library/application icons/weather/codes_conditions/sleet_shower-01.svg2": 80815,
	"./Icon_Library/application icons/weather/codes_conditions/sunny-01.svg2": 87902,
	"./Icon_Library/application icons/weather/codes_conditions/thunder-01.svg2": 54609,
	"./Icon_Library/application icons/weather/codes_conditions/thunder_shower-01.svg2": 51854,
	"./Icon_Library/application icons/weather/codes_conditions/wind_direction.svg2": 13207,
	"./Icon_Library/application icons/weather/codes_conditions/wind_speed-01.svg2": 95011,
	"./Icon_Library/application icons/weather/map_markers/hail.svg2": 75414,
	"./Icon_Library/application icons/weather/map_markers/humidity.svg2": 60305,
	"./Icon_Library/application icons/weather/map_markers/lightning.svg2": 95126,
	"./Icon_Library/application icons/weather/map_markers/precipitation.svg2": 21959,
	"./Icon_Library/application icons/weather/map_markers/pressure.svg2": 34555,
	"./Icon_Library/application icons/weather/map_markers/rain.svg2": 66550,
	"./Icon_Library/application icons/weather/map_markers/snow.svg2": 38459,
	"./Icon_Library/application icons/weather/map_markers/temperature.svg2": 91814,
	"./Icon_Library/application icons/weather/map_markers/uv.svg2": 95223,
	"./Icon_Library/application icons/weather/map_markers/visibility.svg2": 88580,
	"./Icon_Library/application icons/weather/map_markers/wind_direction.svg2": 86780,
	"./Icon_Library/application icons/weather/weather.svg2": 17197,
	"./Icon_Library/cube icons/account_template-01.svg2": 94205,
	"./Icon_Library/cube icons/activation_opt_ins-01.svg2": 21412,
	"./Icon_Library/cube icons/active_groups.svg2": 61844,
	"./Icon_Library/cube icons/add_edit_contacts-01.svg2": 19361,
	"./Icon_Library/cube icons/aggregate-01.svg2": 58600,
	"./Icon_Library/cube icons/aggregate_responses-01.svg2": 59977,
	"./Icon_Library/cube icons/ai_conversations-01.svg2": 6616,
	"./Icon_Library/cube icons/ai_management-01.svg2": 81657,
	"./Icon_Library/cube icons/alerts_notifcations-01.svg2": 5530,
	"./Icon_Library/cube icons/analytical_reporting-01.svg2": 74274,
	"./Icon_Library/cube icons/api_connections-01.svg2": 95179,
	"./Icon_Library/cube icons/assets-01.svg2": 52144,
	"./Icon_Library/cube icons/attachments.svg2": 62853,
	"./Icon_Library/cube icons/boomerang_template-01.svg2": 37094,
	"./Icon_Library/cube icons/boomlogic_projects-01.svg2": 89833,
	"./Icon_Library/cube icons/broadcast-01.svg2": 15632,
	"./Icon_Library/cube icons/bulk_manage-01.svg2": 68679,
	"./Icon_Library/cube icons/comms_delay-01.svg2": 2274,
	"./Icon_Library/cube icons/connections-01.svg2": 57470,
	"./Icon_Library/cube icons/contacts-01.svg2": 32752,
	"./Icon_Library/cube icons/count_collate_data-01.svg2": 55522,
	"./Icon_Library/cube icons/data_analysis-01.svg2": 164,
	"./Icon_Library/cube icons/data_overwrite-01.svg2": 40973,
	"./Icon_Library/cube icons/delay_send-01.svg2": 65109,
	"./Icon_Library/cube icons/delivery_statuses-01.svg2": 6868,
	"./Icon_Library/cube icons/export_reports-01.svg2": 40117,
	"./Icon_Library/cube icons/filtering-01.svg2": 53695,
	"./Icon_Library/cube icons/freebuild-01.svg2": 86395,
	"./Icon_Library/cube icons/generate_reports-01.svg2": 38466,
	"./Icon_Library/cube icons/groups-01.svg2": 84871,
	"./Icon_Library/cube icons/import-01.svg2": 31448,
	"./Icon_Library/cube icons/inbound_campaign-01.svg2": 79535,
	"./Icon_Library/cube icons/inbound_numbers-01.svg2": 65165,
	"./Icon_Library/cube icons/invoices-01.svg2": 39559,
	"./Icon_Library/cube icons/knowledgebase-01.svg2": 38602,
	"./Icon_Library/cube icons/logic_components_library-01.svg2": 83082,
	"./Icon_Library/cube icons/map_pin-01.svg2": 6271,
	"./Icon_Library/cube icons/mapping-01.svg2": 56763,
	"./Icon_Library/cube icons/marketing_fields-01.svg2": 15675,
	"./Icon_Library/cube icons/masking-01.svg2": 22053,
	"./Icon_Library/cube icons/matched_replies-01.svg2": 82176,
	"./Icon_Library/cube icons/number_status-01.svg2": 19653,
	"./Icon_Library/cube icons/number_validation-01.svg2": 76486,
	"./Icon_Library/cube icons/omni_channel-01.svg2": 19964,
	"./Icon_Library/cube icons/paymnet_methods-01.svg2": 52966,
	"./Icon_Library/cube icons/preview-01.svg2": 48657,
	"./Icon_Library/cube icons/process_reports-01.svg2": 49766,
	"./Icon_Library/cube icons/progress_saving-01.svg2": 62803,
	"./Icon_Library/cube icons/real_time_reporting-01.svg2": 54974,
	"./Icon_Library/cube icons/replies-01.svg2": 97997,
	"./Icon_Library/cube icons/reporting-01.svg2": 1503,
	"./Icon_Library/cube icons/saved_reports-01.svg2": 11848,
	"./Icon_Library/cube icons/schedule_send-01.svg2": 12445,
	"./Icon_Library/cube icons/security-01.svg2": 36897,
	"./Icon_Library/cube icons/service_entries-01.svg2": 14125,
	"./Icon_Library/cube icons/service_usage-01.svg2": 88584,
	"./Icon_Library/cube icons/settings-01.svg2": 51892,
	"./Icon_Library/cube icons/shortlinks-01.svg2": 39106,
	"./Icon_Library/cube icons/sla-01.svg2": 35251,
	"./Icon_Library/cube icons/social_hours-01.svg2": 25230,
	"./Icon_Library/cube icons/system_reporting-01.svg2": 3187,
	"./Icon_Library/cube icons/template_library-01.svg2": 16473,
	"./Icon_Library/cube icons/template_qanda-01.svg2": 46341,
	"./Icon_Library/cube icons/ticketing_reports-01.svg2": 82401,
	"./Icon_Library/cube icons/timezones-01.svg2": 84401,
	"./Icon_Library/cube icons/unmatched_replies-01.svg2": 64615,
	"./Icon_Library/cube icons/unrec_responses-01.svg2": 12961,
	"./Icon_Library/cube icons/upgrades-01.svg2": 1732,
	"./Icon_Library/cube icons/user_access_controls-01.svg2": 55364,
	"./Icon_Library/cube icons/variable_data-01.svg2": 7318,
	"./Icon_Library/cube icons/web_forms-01.svg2": 19655,
	"./Icon_Library/cube icons/weighting-01.svg2": 6605,
	"./Icon_Library/solutions icons/app_colouring/sol_app_booking_reminders-01.svg2": 46859,
	"./Icon_Library/solutions icons/app_colouring/sol_app_booking_rescheduling-01.svg2": 48151,
	"./Icon_Library/solutions icons/app_colouring/sol_asset_tracking-01.svg2": 7298,
	"./Icon_Library/solutions icons/app_colouring/sol_booking_requests-01.svg2": 25672,
	"./Icon_Library/solutions icons/app_colouring/sol_business_continuity_comms-01.svg2": 65415,
	"./Icon_Library/solutions icons/app_colouring/sol_collection_reminders-01.svg2": 71838,
	"./Icon_Library/solutions icons/app_colouring/sol_contact_center_eng-01.svg2": 81360,
	"./Icon_Library/solutions icons/app_colouring/sol_contact_center_ivr-01.svg2": 95386,
	"./Icon_Library/solutions icons/app_colouring/sol_contact_management-01.svg2": 496,
	"./Icon_Library/solutions icons/app_colouring/sol_customer_initiated_engagement-01.svg2": 33750,
	"./Icon_Library/solutions icons/app_colouring/sol_debt_recovery-01.svg2": 30461,
	"./Icon_Library/solutions icons/app_colouring/sol_doc_workflow-01.svg2": 40176,
	"./Icon_Library/solutions icons/app_colouring/sol_environmental_monitoring-01.svg2": 20735,
	"./Icon_Library/solutions icons/app_colouring/sol_field_force_comms-01.svg2": 84060,
	"./Icon_Library/solutions icons/app_colouring/sol_field_force_scheduling-01.svg2": 81035,
	"./Icon_Library/solutions icons/app_colouring/sol_inbound_marketing-01.svg2": 22496,
	"./Icon_Library/solutions icons/app_colouring/sol_incident_management-01.svg2": 42606,
	"./Icon_Library/solutions icons/app_colouring/sol_info_requests-01.svg2": 72515,
	"./Icon_Library/solutions icons/app_colouring/sol_instant_auth-01.svg2": 53710,
	"./Icon_Library/solutions icons/app_colouring/sol_iot_monitoring-01.svg2": 75363,
	"./Icon_Library/solutions icons/app_colouring/sol_it_monitoring_alerting-01.svg2": 33003,
	"./Icon_Library/solutions icons/app_colouring/sol_lone_worker-01.svg2": 64643,
	"./Icon_Library/solutions icons/app_colouring/sol_machine_2_machine-01.svg2": 64896,
	"./Icon_Library/solutions icons/app_colouring/sol_marketing_campaigns-01.svg2": 20126,
	"./Icon_Library/solutions icons/app_colouring/sol_membership_sub_management-01.svg2": 31977,
	"./Icon_Library/solutions icons/app_colouring/sol_mustering-01.svg2": 31156,
	"./Icon_Library/solutions icons/app_colouring/sol_opt_in_opt_out_management-01.svg2": 42200,
	"./Icon_Library/solutions icons/app_colouring/sol_order_delivery_management-01.svg2": 64425,
	"./Icon_Library/solutions icons/app_colouring/sol_payment_reminders-01.svg2": 72564,
	"./Icon_Library/solutions icons/app_colouring/sol_resource_managment_fulfilment-01.svg2": 46032,
	"./Icon_Library/solutions icons/app_colouring/sol_service_desk_ticketing-01.svg2": 76060,
	"./Icon_Library/solutions icons/app_colouring/sol_service_sla-01.svg2": 15500,
	"./Icon_Library/solutions icons/app_colouring/sol_shift_planning-01.svg2": 76286,
	"./Icon_Library/solutions icons/app_colouring/sol_sub_renewals-01.svg2": 21208,
	"./Icon_Library/solutions icons/app_colouring/sol_survey_sms-01.svg2": 23266,
	"./Icon_Library/solutions icons/app_colouring/sol_survey_web-01.svg2": 83431,
	"./Icon_Library/solutions icons/app_colouring/sol_traffic_alerts-01.svg2": 75621,
	"./Icon_Library/solutions icons/app_colouring/sol_weather_alerts-01.svg2": 66384,
	"./Icon_Library/solutions icons/sol_app_booking_reminders-01.svg2": 13246,
	"./Icon_Library/solutions icons/sol_app_booking_rescheduling-01.svg2": 13928,
	"./Icon_Library/solutions icons/sol_asset_tracking-01.svg2": 95065,
	"./Icon_Library/solutions icons/sol_booking_requests-01.svg2": 77407,
	"./Icon_Library/solutions icons/sol_business_continuity_comms-01.svg2": 22430,
	"./Icon_Library/solutions icons/sol_collection_reminders-01.svg2": 25113,
	"./Icon_Library/solutions icons/sol_contact_center_eng-01.svg2": 64020,
	"./Icon_Library/solutions icons/sol_contact_center_ivr-01.svg2": 31269,
	"./Icon_Library/solutions icons/sol_contact_management-01.svg2": 10859,
	"./Icon_Library/solutions icons/sol_customer_initiated_engagement-01.svg2": 1615,
	"./Icon_Library/solutions icons/sol_debt_recovery-01.svg2": 96624,
	"./Icon_Library/solutions icons/sol_doc_workflow-01.svg2": 98539,
	"./Icon_Library/solutions icons/sol_environmental_monitoring-01.svg2": 44008,
	"./Icon_Library/solutions icons/sol_field_force_comms-01.svg2": 24089,
	"./Icon_Library/solutions icons/sol_field_force_scheduling-01.svg2": 11496,
	"./Icon_Library/solutions icons/sol_inbound_marketing-01.svg2": 82837,
	"./Icon_Library/solutions icons/sol_incident_management-01.svg2": 88103,
	"./Icon_Library/solutions icons/sol_info_requests-01.svg2": 72966,
	"./Icon_Library/solutions icons/sol_instant_auth-01.svg2": 43805,
	"./Icon_Library/solutions icons/sol_iot_monitoring-01.svg2": 89392,
	"./Icon_Library/solutions icons/sol_it_monitoring_alerting-01.svg2": 11304,
	"./Icon_Library/solutions icons/sol_lone_worker-01.svg2": 49834,
	"./Icon_Library/solutions icons/sol_machine_2_machine-01.svg2": 53285,
	"./Icon_Library/solutions icons/sol_marketing_campaigns-01.svg2": 34847,
	"./Icon_Library/solutions icons/sol_membership_sub_management-01.svg2": 84924,
	"./Icon_Library/solutions icons/sol_mustering-01.svg2": 20165,
	"./Icon_Library/solutions icons/sol_opt_in_opt_out_management-01.svg2": 13017,
	"./Icon_Library/solutions icons/sol_order_delivery_management-01.svg2": 81724,
	"./Icon_Library/solutions icons/sol_payment_reminders-01.svg2": 38361,
	"./Icon_Library/solutions icons/sol_resource_managment_fulfilment-01.svg2": 30733,
	"./Icon_Library/solutions icons/sol_service_desk_ticketing-01.svg2": 3955,
	"./Icon_Library/solutions icons/sol_service_sla-01.svg2": 47633,
	"./Icon_Library/solutions icons/sol_shift_planning-01.svg2": 69205,
	"./Icon_Library/solutions icons/sol_sub_renewals-01.svg2": 91699,
	"./Icon_Library/solutions icons/sol_survey_sms-01.svg2": 44025,
	"./Icon_Library/solutions icons/sol_survey_web-01.svg2": 55036,
	"./Icon_Library/solutions icons/sol_traffic_alerts-01.svg2": 86994,
	"./Icon_Library/solutions icons/sol_weather_alerts-01.svg2": 81895,
	"./add_circle-01.svg2": 60905,
	"./alerts.svg2": 41564,
	"./api_cog-01.svg2": 24627,
	"./api_connections.svg2": 68203,
	"./api_type-01.svg2": 85318,
	"./arrow_right-01.svg2": 61067,
	"./asset-01.svg2": 80639,
	"./attach.svg2": 19742,
	"./billing_overview.svg2": 86492,
	"./bolt.svg2": 64180,
	"./boom_calendar-01.svg2": 92449,
	"./boomerang_element-01.svg2": 64674,
	"./boomlocal-forward.svg2": 2091,
	"./briefcase.svg2": 20577,
	"./bulk_manage.svg2": 70271,
	"./button_logic_ready.svg2": 64270,
	"./cal_basic-01.svg2": 50564,
	"./cal_event-01.svg2": 25150,
	"./calendar.svg2": 52133,
	"./chevon_down.svg2": 22679,
	"./close.svg2": 47809,
	"./cog.svg2": 39442,
	"./comm_fields.svg2": 74261,
	"./comms-delay.svg2": 70246,
	"./componenets.svg2": 85720,
	"./concat.svg2": 65543,
	"./connections.svg2": 40732,
	"./contact_edit.svg2": 26338,
	"./contact_support.svg2": 92553,
	"./contacts_main.svg2": 64930,
	"./contacts_main_nav.svg2": 76448,
	"./create_api_connection.svg2": 31157,
	"./create_boomlogic.svg2": 86763,
	"./create_broadcast.svg2": 33947,
	"./create_inbound.svg2": 64717,
	"./customers.svg2": 74396,
	"./data_mapping-01.svg2": 40678,
	"./docs.svg2": 97272,
	"./edit-01.svg2": 35133,
	"./edit.svg2": 97731,
	"./engineer.svg2": 99482,
	"./engineer_visit.svg2": 7814,
	"./export.svg2": 3665,
	"./features.svg2": 2560,
	"./filter.svg2": 39085,
	"./filter_solid.svg2": 34709,
	"./free_build.svg2": 84310,
	"./fulfilment.svg2": 20609,
	"./global_settings.svg2": 24844,
	"./groups.svg2": 55223,
	"./groups_add.svg2": 14655,
	"./hail.svg2": 99037,
	"./humidity.svg2": 64594,
	"./icon_1_way-01.svg2": 64294,
	"./icon_2_way-01.svg2": 30321,
	"./icon_activation_criteria-01.svg2": 57723,
	"./icon_activation_keywords-01.svg2": 19280,
	"./icon_address-01.svg2": 18431,
	"./icon_api_endpoints-01.svg2": 18228,
	"./icon_clicks-01.svg2": 39626,
	"./icon_communications-01.svg2": 64094,
	"./icon_contact_data_types-01.svg2": 47916,
	"./icon_contacts-01.svg2": 4670,
	"./icon_counter-01.svg2": 86543,
	"./icon_data_variables-01.svg2": 96775,
	"./icon_date_picker-01.svg2": 50606,
	"./icon_date_time-01.svg2": 3535,
	"./icon_distance-01.svg2": 75424,
	"./icon_duration-01.svg2": 11305,
	"./icon_email-01.svg2": 31675,
	"./icon_group-01.svg2": 79618,
	"./icon_inbound-01.svg2": 38588,
	"./icon_mobile_number-01.svg2": 58125,
	"./icon_rcs-01.svg2": 71887,
	"./icon_recipients-01.svg2": 61685,
	"./icon_repeat-01.svg2": 35704,
	"./icon_replies-01.svg2": 85184,
	"./icon_reporting_financials_white-01.svg2": 45882,
	"./icon_reports-01.svg2": 91974,
	"./icon_responders-01.svg2": 37980,
	"./icon_save-01.svg2": 39750,
	"./icon_shorttext-01.svg2": 21236,
	"./icon_status-01.svg2": 90195,
	"./icon_voice_tel-01.svg2": 17879,
	"./icon_warning-01.svg2": 11059,
	"./icon_weather_header.svg2": 63339,
	"./icon_weather_header_c-01.svg2": 68935,
	"./icon_weather_header_dark.svg2": 75804,
	"./icon_whatsapp-01.svg2": 19435,
	"./import-01.svg2": 94738,
	"./import_side-01.svg2": 89248,
	"./inbound_numbers.svg2": 8137,
	"./incident_report.svg2": 36280,
	"./info-01.svg2": 85497,
	"./info.svg2": 11263,
	"./interactions.svg2": 17546,
	"./interactions_nav.svg2": 38344,
	"./invoice_history.svg2": 23101,
	"./invoicing.svg2": 80921,
	"./knowledgebase-01.svg2": 26276,
	"./ldap-01.svg2": 80378,
	"./library_broadcast.svg2": 44918,
	"./library_documents.svg2": 57959,
	"./library_logic.svg2": 73963,
	"./library_puzzle.svg2": 37615,
	"./lightning.svg2": 32255,
	"./live_chat.svg2": 58100,
	"./logout.svg2": 20025,
	"./mapping.svg2": 31359,
	"./marketing_fields.svg2": 98791,
	"./masking.svg2": 89773,
	"./menu.svg2": 5936,
	"./message_recipients.svg2": 72119,
	"./messages-01.svg2": 4681,
	"./messages.svg2": 58575,
	"./messages_processed-01.svg2": 9608,
	"./messages_processed.svg2": 37752,
	"./messenger.svg2": 69374,
	"./monitoring/alerts_notifications-01.svg2": 34594,
	"./monitoring/check_tick-01.svg2": 53594,
	"./monitoring/configuration-01.svg2": 75680,
	"./monitoring/icon_ping (1).svg2": 15714,
	"./monitoring/industries/industry_construction-01.svg2": 2075,
	"./monitoring/map_view-01.svg2": 30420,
	"./monitoring/monitor_types/icon_alert.svg2": 28083,
	"./monitoring/monitor_types/mon_environmental_conditions-01.svg2": 44445,
	"./monitoring/monitor_types/mon_remote_devices-01.svg2": 48574,
	"./monitoring/monitor_types/mon_weather.svg2": 90656,
	"./monitoring/monitor_types/mon_welfare-01.svg2": 88320,
	"./monitoring/monitoring-01.svg2": 29912,
	"./monitoring/monitors_overview-01.svg2": 28367,
	"./monitoring/save-01.svg2": 90473,
	"./monitoring/select_workflow-01.svg2": 82054,
	"./monitoring/setup-01.svg2": 72249,
	"./monitoring/view_manage_monitors-01.svg2": 50113,
	"./movable-01.svg2": 78309,
	"./movable.svg2": 27147,
	"./nav_billing.svg2": 10652,
	"./nav_contacts.svg2": 46292,
	"./nav_dashboard.svg2": 22339,
	"./nav_monitoring-01.svg2": 53117,
	"./nav_reports.svg2": 13836,
	"./nav_settings.svg2": 97216,
	"./nav_templates.svg2": 22520,
	"./num-status.svg2": 27614,
	"./num-validation.svg2": 56923,
	"./nylas.svg2": 31622,
	"./omni-channel.svg2": 6024,
	"./opt-in-out.svg2": 52497,
	"./originator.svg2": 60157,
	"./overview-01.svg2": 73216,
	"./payment_methods.svg2": 79830,
	"./personal_details.svg2": 46390,
	"./plus.svg2": 40527,
	"./precipitation.svg2": 28642,
	"./prepaid.svg2": 88070,
	"./pressure.svg2": 30696,
	"./preview.svg2": 84493,
	"./print.svg2": 71242,
	"./process_reports.svg2": 51716,
	"./prod_api.svg2": 49177,
	"./prod_boomlogic.svg2": 53526,
	"./prod_broadcast.svg2": 9026,
	"./prod_inbound.svg2": 40904,
	"./profile_fields.svg2": 93312,
	"./rain.svg2": 37073,
	"./realtime_reporting.svg2": 90067,
	"./redo.svg2": 3403,
	"./reporting-01.svg2": 24337,
	"./reporting_analytical.svg2": 9686,
	"./reporting_system.svg2": 461,
	"./reports_export.svg2": 35553,
	"./reports_generate.svg2": 54792,
	"./reports_saved.svg2": 24814,
	"./required_fields.svg2": 6974,
	"./satisfaction_survey.svg2": 95266,
	"./save.svg2": 20138,
	"./schedule_send.svg2": 6585,
	"./scheduling.svg2": 51813,
	"./search.svg2": 67019,
	"./secure_lock..svg2": 79478,
	"./security.svg2": 71945,
	"./self-manage.svg2": 14279,
	"./send.svg2": 33813,
	"./service_entries.svg2": 53885,
	"./settings.svg2": 29226,
	"./shortlink.svg2": 94715,
	"./shortlink2.svg2": 82627,
	"./sla.svg2": 57507,
	"./sms_text.svg2": 19962,
	"./snow.svg2": 40248,
	"./social-hours.svg2": 8822,
	"./social_fb-01.svg2": 85063,
	"./social_fb.svg2": 59953,
	"./social_hours-01.svg2": 80356,
	"./social_li-01.svg2": 59662,
	"./social_li.svg2": 65050,
	"./social_x-01.svg2": 65377,
	"./social_x.svg2": 59719,
	"./status.svg2": 98453,
	"./support_ticket.svg2": 15279,
	"./switch_refresh.svg2": 68595,
	"./system_usage-01.svg2": 91770,
	"./system_usage.svg2": 45046,
	"./temperature.svg2": 1212,
	"./template_account.svg2": 93585,
	"./template_boomerang.svg2": 6542,
	"./template_helper.svg2": 2958,
	"./template_rec.svg2": 33872,
	"./tick.svg2": 74494,
	"./tick_circled.svg2": 38193,
	"./tick_list.svg2": 80151,
	"./tiket_reporting.svg2": 11441,
	"./timezones.svg2": 78177,
	"./undo.svg2": 96949,
	"./unicode.svg2": 79890,
	"./unrec-response.svg2": 18162,
	"./upgrades.svg2": 2678,
	"./upload.svg2": 58790,
	"./upload_file-01.svg2": 23355,
	"./user_group-01.svg2": 95324,
	"./user_group.svg2": 10460,
	"./uv.svg2": 61048,
	"./visibility.svg2": 28415,
	"./weather_conditions_icons/clear_sky-01.svg2": 79263,
	"./weather_conditions_icons/cloudy-01.svg2": 76562,
	"./weather_conditions_icons/drizzle-01.svg2": 81104,
	"./weather_conditions_icons/fog-01.svg2": 19706,
	"./weather_conditions_icons/gust-01.svg2": 37855,
	"./weather_conditions_icons/heavy_rain-01.svg2": 31424,
	"./weather_conditions_icons/heavy_rain_shower-01.svg2": 7353,
	"./weather_conditions_icons/heavy_snow-01.svg2": 43923,
	"./weather_conditions_icons/heavy_snow_shower-01.svg2": 46848,
	"./weather_conditions_icons/humidity-01.svg2": 25661,
	"./weather_conditions_icons/light_rain-01.svg2": 13967,
	"./weather_conditions_icons/light_rain_shower-01.svg2": 62164,
	"./weather_conditions_icons/light_snow-01.svg2": 74384,
	"./weather_conditions_icons/light_snow_shower-01.svg2": 80009,
	"./weather_conditions_icons/max_screen_temp-01.svg2": 20968,
	"./weather_conditions_icons/min_screen_temp-01.svg2": 50702,
	"./weather_conditions_icons/mist-01.svg2": 36165,
	"./weather_conditions_icons/overcast-01.svg2": 86857,
	"./weather_conditions_icons/partly_cloudy-01.svg2": 44435,
	"./weather_conditions_icons/probability_hail-01.svg2": 23648,
	"./weather_conditions_icons/probability_of_snow_visibility-01.svg2": 38776,
	"./weather_conditions_icons/probability_precipitation-01.svg2": 42003,
	"./weather_conditions_icons/probability_sferics-01.svg2": 59339,
	"./weather_conditions_icons/sea-level-pressure-01.svg2": 26498,
	"./weather_conditions_icons/significant_weather-01.svg2": 95438,
	"./weather_conditions_icons/sleet-01.svg2": 70903,
	"./weather_conditions_icons/sleet_shower-01.svg2": 10620,
	"./weather_conditions_icons/sunny-01.svg2": 82915,
	"./weather_conditions_icons/thunder-01.svg2": 48468,
	"./weather_conditions_icons/thunder_shower-01.svg2": 28437,
	"./weather_conditions_icons/uv-index-01.svg2": 92776,
	"./weather_conditions_icons/weather_conditions.svg2": 22213,
	"./weather_conditions_icons/weather_conditions_alt.svg2": 86217,
	"./weather_conditions_icons/wind_direction.svg2": 80370,
	"./weather_conditions_icons/wind_direction_old.svg2": 78956,
	"./weather_conditions_icons/wind_speed-01.svg2": 2424,
	"./weather_conditions_icons/wind_speed-01_old.svg2": 60634,
	"./web-forms.svg2": 2993,
	"./whatsapp.svg2": 25757,
	"./wind_direction.svg2": 92443,
	"./workflows.svg2": 81427,
	"./xls_files-01.svg2": 29672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94929;